// Imports
import styled from 'styled-components';

// Main Component
const FormHelperTextStyles = styled.span``;

// Export
export default FormHelperTextStyles;
